/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Edit_Field_TypeInputs */

const en_task_edit_field_type = /** @type {(inputs: Task_Edit_Field_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task type`)
};

const pt_br2_task_edit_field_type = /** @type {(inputs: Task_Edit_Field_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de atividade`)
};

/**
* | output |
* | --- |
* | "Task type" |
*
* @param {Task_Edit_Field_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_edit_field_type = /** @type {((inputs?: Task_Edit_Field_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Edit_Field_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_edit_field_type(inputs)
	return pt_br2_task_edit_field_type(inputs)
});